import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { HeaderToolbarComponent } from '../../layout/header-toolbar/header-toolbar.component';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  imports: [MatButton, RouterLink, HeaderToolbarComponent],
})
export class PageNotFoundComponent {}
